import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  items: string[];
}
export function ServiceCard({
  title,
  description,
  icon,
  items
}: ServiceCardProps) {
  return <div className="bg-white p-8 rounded-xl border border-slate-200 hover:border-blue-200 hover:shadow-lg transition-all" data-id="element-212">
      <div className="w-14 h-14 bg-blue-50 text-blue-900 rounded-lg flex items-center justify-center mb-6" data-id="element-213">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-214">{title}</h3>
      <p className="text-slate-600 mb-6" data-id="element-215">{description}</p>
      <ul className="space-y-3 mb-8" data-id="element-216">
        {items.map((item, index) => <li key={index} className="flex items-start text-sm text-slate-700" data-id="element-217">
            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-1.5 mr-3 flex-shrink-0" data-id="element-218"></span>
            {item}
          </li>)}
      </ul>
    </div>;
}